import classnames from 'classnames';
import { cloneElement } from 'react';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { CSSTransitionProps } from 'react-transition-group/CSSTransition';
import { Timeout, TIMEOUTS } from './constants';
import './styles/Transition.scss';

type TransitionProps = Omit<CSSTransitionProps, 'timeout' | 'in' | 'appear'> & {
    timeout?: Timeout;
    show?: boolean;
    appear?: boolean;
    property?: string;
    className?: string;
    children: React.ReactNode;
    unmountOnExit?: boolean;
};

function Transition({
    timeout = 'medium',
    show = false,
    children,
    appear = false,
    property = 'all',
    unmountOnExit,
    onEnter,
    onEntered,
    onExited,
    className,
}: TransitionProps) {
    const nodeRef = React.useRef<HTMLElement | undefined>(null);

    return (
        <CSSTransition
            appear={appear}
            classNames="palette-transition"
            in={show}
            nodeRef={nodeRef}
            timeout={TIMEOUTS[timeout]}
            unmountOnExit={unmountOnExit}
            onEnter={onEnter}
            onEntered={onEntered}
            onExited={onExited}
        >
            {React.isValidElement(children) ? cloneElement(
                children,
                {
                    ...children.props,
                    className: classnames(
                        className,
                        children.props.className,
                        `palette-transition palette-transition--duration-${timeout}`,
                    ),
                    style: { ...children.props.style, transitionProperty: property },
                    ref: nodeRef,
                },
            ) : null}
        </CSSTransition>
    );
}

export type { TransitionProps };
export default Transition;
